import axios, { AxiosResponse } from 'axios'
import {
  BaseEntity,
  Identity,
  VendorGroupAttributes,
  Resource,
  ResourceTypes,
  SingleResourceResponse,
  VendorGroup,
  ResourceId,
} from '@vendorflow/types'

import { AZIMUTH_API_URL, VERSION } from 'constants/Api.constants'
import { convertResourceToEntity } from '@vendorflow/common/lib/converters/JsonApi.converter'
import { AUTHORIZATION_SENTINEL } from 'features/auth/Auth.constants'
const VENDOR_GROUP_URL = `${AZIMUTH_API_URL}/${VERSION}/vendorGroups`

export async function fetchVendorGroupUsingGET(id: string): Promise<VendorGroup> {
  const result: AxiosResponse<SingleResourceResponse<VendorGroup, ResourceTypes.VENDOR_GROUPS>> = await axios.get(
    `${VENDOR_GROUP_URL}/${id}`,
    {
      headers: { Authorization: AUTHORIZATION_SENTINEL },
    }
  )
  return convertResourceToEntity(result.data.data)
}

export async function renameVendorGroupUsingPUT(id: string, vendorGroup: VendorGroupAttributes): Promise<VendorGroup> {
  const result: AxiosResponse<SingleResourceResponse<VendorGroup, ResourceTypes.VENDOR_GROUPS>> = await axios.request({
    method: 'PUT',
    url: `${VENDOR_GROUP_URL}/${id}`,
    data: {
      data: {
        attributes: {
          name: vendorGroup.name,
          description: vendorGroup.description,
        },
        type: ResourceTypes.VENDOR_GROUPS,
      },
    },
    headers: { Authorization: AUTHORIZATION_SENTINEL },
  })
  return convertResourceToEntity(result.data.data)
}

export async function deleteVendorGroupUsingDELETE(id: string): Promise<VendorGroup> {
  const result: AxiosResponse<SingleResourceResponse<VendorGroup, ResourceTypes.VENDOR_GROUPS>> = await axios.request({
    method: 'DELETE',
    url: `${VENDOR_GROUP_URL}/${id}`,
    headers: { Authorization: AUTHORIZATION_SENTINEL },
  })

  return convertResourceToEntity(result.data.data)
}

export async function fetchAllVendorsForVendorGroupUsingGET(id: string): Promise<Identity[]> {
  const result: AxiosResponse<SingleResourceResponse<VendorGroup, ResourceTypes.VENDOR_GROUPS>> = await axios.request({
    method: 'GET',
    url: `${VENDOR_GROUP_URL}/${id}?include=includes`,
    headers: { Authorization: AUTHORIZATION_SENTINEL },
  })

  return (
    result.data.included?.map((item: Resource<Identity, ResourceTypes.IDENTITIES>) => convertResourceToEntity(item)) ||
    []
  )
}

export async function addVendorsToVendorGroupUsingPOST(
  id: string,
  identityIds: BaseEntity<ResourceTypes.IDENTITIES>[]
): Promise<void> {
  await axios.request({
    method: 'POST',
    url: `${VENDOR_GROUP_URL}/${id}/rel/includes`,
    data: { data: identityIds },
    headers: { Authorization: AUTHORIZATION_SENTINEL },
  })
}

export async function removeVendorsFromVendorGroupUsingDELETE(
  id: string,
  identityIds: BaseEntity<ResourceTypes.IDENTITIES>[]
): Promise<SingleResourceResponse<VendorGroup, ResourceTypes.VENDOR_GROUPS>> {
  const result: AxiosResponse<SingleResourceResponse<VendorGroup, ResourceTypes.VENDOR_GROUPS>> = await axios.request({
    method: 'DELETE',
    url: `${VENDOR_GROUP_URL}/${id}/rel/includes`,
    data: { data: identityIds },
    headers: { Authorization: AUTHORIZATION_SENTINEL },
  })

  return result.data
}

export async function fetchWatchersForVendorGroupUsingGET(id: string) {
  const result: AxiosResponse<{ data: ResourceId<ResourceTypes.IDENTITIES>[] }> = await axios.request({
    method: 'GET',
    url: `${VENDOR_GROUP_URL}/${id}/rel/watchedBy`,
    headers: { Authorization: AUTHORIZATION_SENTINEL },
  })

  return result.data.data
}
